import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { PortfolioMonthlyStatement } from '@/modules/wealth/services/portfolio';

import { BaseIcon, Row, LoaderIndicator } from '@warrenbrasil/nebraska-web';

interface Props {
  statement: PortfolioMonthlyStatement;
  disabled: boolean;
  loading: boolean;
}
interface Emits {
  (event: 'on-click'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StatementRow',
  props: {
    statement: null,
    disabled: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["on-click"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'on-click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  statement: PortfolioMonthlyStatement;
  disabled: boolean;
  loading: boolean;
}





const computedClass = computed(() => {
  return {
    'statement-row--disabled': props.disabled,
    'statement-row--loading': props.loading
  };
});

const onClick = () => {
  if (props.disabled || props.loading) return;
  emit('on-click');
};

return { __sfc: true,props, emit, computedClass, onClick, BaseIcon, Row, LoaderIndicator }
}

})